import { useContext, useEffect, useState } from "react";
import Word from "./Word";
import CurrentContext from "./CurrentContext";

export default function MeasureTool({
    measureDimension
}) {
  const { autoRotate, setAutorotate, isMeasure, setIsMeasure } =
    useContext(CurrentContext);
  const [showBoundingBox, setShowBoundingBox] = useState(false);
  const measureOffset = [0, 0, 0];
  const gap = 0.1;
  const { cap_t,
    cap_e,
    height,
    width,
    depth,
    textHeight,
    textWidth,
    textDepth,} = measureDimension;

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.altKey && (event.key === "b" || event.key === "B")) {
        setShowBoundingBox((prevKeyPressed) => !prevKeyPressed);
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  function setRotation(x, y, z) {
    return [(Math.PI / 180) * x, (Math.PI / 180) * y, (Math.PI / 180) * z];
  }

  // console.log(
  //   "Object Dimentions: ",
  //   "\nw: ",width,textWidth,
  //   "\nd: ",depth,textDepth,
  //   "\nh: ",height,textHeight,
  // );
  // console.log(boundingbox,"boundingboxboundingbox")
  return (
    <>
      <group visible={isMeasure} position={measureOffset}>
        {/* Bounding Box */}
        <mesh
          position={[0, height / 2, 0]}
          rotation={setRotation(0, 0, 0)}
          visible={showBoundingBox} //set to true if you want to see the bounding box
        >
          <boxGeometry attach="geometry" args={[width, height, depth]} />
          <meshStandardMaterial
            attach="material"
            color="#ff0000"
            opacity={0.5}
          />
        </mesh>
        {/* height */}
        <mesh
          position={[-width / 2 - gap, height / 2, -depth / 2 - gap]}
          rotation={setRotation(0, 0, 0)}
        >
          <cylinderGeometry
            attach="geometry"
            args={[cap_t, cap_e, height, 16]}
          />
          <meshStandardMaterial attach="material" color="#000000" />
        </mesh>
        <mesh
          position={[-width / 2 - gap / 1.2, height, -depth / 2 - gap / 1.2]}
          rotation={setRotation(90, 0, -45)}
        >
          <cylinderGeometry
            attach="geometry"
            args={[cap_t, cap_e, gap / 2, 16]}
          />
          <meshStandardMaterial attach="material" color="#000000" />
        </mesh>
        <mesh
          position={[-width / 2 - gap / 1.2, 0, -depth / 2 - gap / 1.2]}
          rotation={setRotation(90, 0, -45)}
        >
          <cylinderGeometry
            attach="geometry"
            args={[cap_t, cap_e, gap / 2, 16]}
          />
          <meshStandardMaterial attach="material" color="#000000" />
        </mesh>
        {/* width */}
        <mesh
          position={[0, 0, depth / 2 + gap]}
          rotation={setRotation(90, 0, 90)}
        >
          <cylinderGeometry
            attach="geometry"
            args={[cap_t, cap_e, width, 16]}
          />
          <meshStandardMaterial attach="material" color="#000000" />
        </mesh>
        <mesh
          position={[-width / 2, 0, depth / 2 + 0.75 * gap]}
          rotation={setRotation(90, 0, 0)}
        >
          <cylinderGeometry
            attach="geometry"
            args={[cap_t, cap_e, gap / 2, 16]}
          />
          <meshStandardMaterial attach="material" color="#000000" />
        </mesh>
        <mesh
          position={[width / 2, 0, depth / 2 + 0.75 * gap]}
          rotation={setRotation(90, 0, 0)}
        >
          <cylinderGeometry
            attach="geometry"
            args={[cap_t, cap_e, gap / 2, 16]}
          />
          <meshStandardMaterial attach="material" color="#000000" />
        </mesh>
        {/* depth */}
        <mesh
          position={[-width / 2 - gap, 0, 0]}
          rotation={setRotation(90, 0, 0)}
        >
          <cylinderGeometry
            attach="geometry"
            args={[cap_t, cap_e, depth, 16]}
          />
          <meshStandardMaterial attach="material" color="#000000" />
        </mesh>
        <mesh
          position={[-width / 2 - 0.75 * gap, 0, -depth / 2]}
          rotation={setRotation(90, 0, 90)}
        >
          <cylinderGeometry
            attach="geometry"
            args={[cap_t, cap_e, gap / 2, 16]}
          />
          <meshStandardMaterial attach="material" color="#000000" />
        </mesh>
        <mesh
          position={[-width / 2 - 0.75 * gap, 0, depth / 2]}
          rotation={setRotation(90, 0, 90)}
        >
          <cylinderGeometry
            attach="geometry"
            args={[cap_t, cap_e, gap / 2, 16]}
          />
          <meshStandardMaterial attach="material" color="#000000" />
        </mesh>
        <Word
          title={textHeight}
          position={[
            -width / 2 - 1.25 * gap,
            height / 2,
            -depth / 2 - 1.25 * gap,
          ]}
          rotation={setRotation(0, -45, 90)}
          range
        />
        <Word
          title={textWidth}
          position={[0, gap / 2, depth / 2 + gap]}
          rotation={setRotation(-45, 0, 0)}
          range
        />
        <Word
          title={textDepth}
          position={[-width / 2 - gap, gap / 2, 0]}
          rotation={setRotation(-90, -45, -90)}
          range
        />
      </group>
    </>
  );
}
